import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetRegistrationModel } from "@factory/model/query-model-registration";
import { registrationFormDefault } from "./form.default";
import { RegistrationFormSchema } from "./form.rule";

export const useFormDefaultRegistration = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetRegistrationModel | undefined) => {
    return !cachedValue
      ? registrationFormDefault
      : ({
          tenant: cachedValue.tenant,
          firstName: cachedValue.first_name,
          middleName: cachedValue.middle_name,
          lastName: cachedValue.last_name,
          birthday: cachedValue.birthday,
          gender: cachedValue.gender,
          address: cachedValue.address,
          mobileNumber: cachedValue.mobile_number,
          avatar: cachedValue.avatar,
          email: cachedValue.email,
          isTakingMedication: Boolean(cachedValue.is_taking_medication),
          medicationDetails: cachedValue.medication_details,
          hasAllergies: Boolean(cachedValue.has_allergies),
          allergyDetails: cachedValue.allergy_details,
          hasMedicalConditions: Boolean(cachedValue.has_medical_conditions),
          medicalConditonDetails: cachedValue.medical_conditon_details,
          wasRecentlyUnwell: Boolean(cachedValue.was_recently_unwell),
          unwellDetails: cachedValue.unwell_details,
          otherMedicalConditions: cachedValue.other_medical_conditions,
          service: cachedValue.service,
          date: cachedValue.date,
          time: cachedValue.time,
          otherRemarks: cachedValue.other_remarks,
          status: cachedValue.status,
        } as RegistrationFormSchema);
  };

  return {
    getDefault,
  };
};
